export default class WasteTippingService {
    update = (providerId, tippingId, data) => {
        return axios.patch(`/providers/${providerId}/waste-tipping/${tippingId}/update`, data);
    }
}

